import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './carouselCoding.css'; // Add your styles here
import TypingPythonCode from '../typingCode/typingPythonCode/TypingPythonCode';
import TypingCppCode from '../typingCode/typingPythonCode/TypingCppCode';
import TypingMatlabCode from '../typingCode/typingPythonCode/TypingMatlabCode';
import TypingCSharpCode from '../typingCode/typingPythonCode/TypingCSharpCode';
import TypingSQLCode from '../typingCode/typingPythonCode/TypingSQLCode';
import TypingJavaScriptCode from '../typingCode/typingPythonCode/TypingJavaScriptCode';


// Custom Arrow Components
const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', left: '-40px', zIndex: 1 }} // Customize button position
      onClick={onClick}
    >
      <button style={styles.button}>◀</button>
    </div>
  );
};

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', right: '-40px', zIndex: 1 }} // Customize button position
      onClick={onClick}
    >
      <button style={styles.button}>▶</button>
    </div>
  );
};

const CarouselCoding = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <div className="carousel-container" style={styles.container}>
      <Slider {...settings}>
        <div className="carousel-slide">
          <h2 style={styles.title}>Python</h2>
          <div style={styles.content}><TypingPythonCode /></div>
          <p style={styles.text}>From simple educationl projects to real-world projects in Deep Learning.</p>
        </div>
        <div className="carousel-slide">
          <h2 style={styles.title}>C/C++</h2>
          <div style={styles.content}><TypingCppCode /></div>
          <p style={styles.text}>The programming language I use for university and work</p>
        </div>
        <div className="carousel-slide">
          <h2 style={styles.title}>JavaScript</h2>
          <div style={styles.content}><TypingJavaScriptCode /></div>
          <p style={styles.text}>I develop both Front- and Backend with JS</p>
        </div>
        <div className="carousel-slide">
          <h2 style={styles.title}>C#</h2>
          <div style={styles.content}><TypingCSharpCode /></div>
          <p style={styles.text}>I avoid C# by choice, not by limitation</p>
        </div>
        <div className="carousel-slide">
          <h2 style={styles.title}>SQL</h2>
          <div style={styles.content}><TypingSQLCode /></div>
          <p style={styles.text}>For Data Engineering and Cleaning</p>
        </div>
      </Slider>
    </div>
  );
};

// Styling for the buttons and carousel
const styles = {
  container: {
    width: '80%',
    margin: '0 auto',
  },
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '10px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontSize: '14px',
    textAlign: 'center',
  },
  button: {
    backgroundColor: 'black',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    display: 'inline-block',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    cursor: 'pointer',
    outline: 'none',
  },
};

export default CarouselCoding;